import React from "react";
import { ArrowRight, Sparkles, Star, Instagram } from "lucide-react";
import { BRAND, STATS } from "../mock/mock";
import ReelsRow from "./ReelsRow";
import { useBooking } from "../context/BookingContext";

export default function HeroV2() {
  const { openBook } = useBooking();
  return (
    <section id="top" className="relative pt-32 md:pt-40 pb-14 overflow-hidden">
      {/* soft boho glows */}
      <div className="absolute -top-40 -left-32 w-[520px] h-[520px] rounded-full blur-3xl opacity-30" style={{ background: "radial-gradient(circle, rgba(201,161,90,0.4), transparent 70%)" }} />
      <div className="absolute top-24 -right-40 w-[500px] h-[500px] rounded-full blur-3xl opacity-25" style={{ background: "radial-gradient(circle, rgba(217,138,154,0.4), transparent 70%)" }} />

      <div className="relative max-w-4xl mx-auto px-5 text-center">
        <div className="flex flex-wrap items-center justify-center gap-2.5 mb-7">
          <span className="inline-flex items-center gap-2 text-xs px-4 py-2 rounded-full border hairline text-gold-soft bg-viimii-2/60">
            <Sparkles size={13} /> Luxury Boho Studio
          </span>
          <span className="inline-flex items-center gap-1.5 text-xs px-4 py-2 rounded-full border hairline text-cream/80 bg-viimii-2/60">
            <Star size={12} className="fill-current" style={{ color: "var(--viimii-gold)" }} /> {BRAND.rating}★ Google
          </span>
          <span className="inline-flex items-center gap-2 text-xs px-4 py-2 rounded-full border hairline text-cream/80 bg-viimii-2/60">
            Kandivali West, Mumbai
          </span>
        </div>

        <img src="/brand/viimii-word-dark.png" alt="VIIMII STUDIO" className="h-12 md:h-16 w-auto mx-auto mb-6" />

        <h1 className="font-display text-4xl sm:text-5xl md:text-[4.2rem] leading-[1.02] font-semibold">
          Nails, Lashes & <span className="gold-gradient-text italic">Hair Spa</span>
          <br className="hidden sm:block" /> crafted like <span className="gold-gradient-text italic">art.</span>
        </h1>

        <p className="mt-6 text-cream/70 text-base md:text-lg max-w-2xl mx-auto leading-relaxed">
          Step into Mumbai's boho-luxe beauty destination - where every set of nails,
          every lash and every spa ritual is designed to make you feel effortlessly beautiful.
        </p>

        <div className="mt-9 flex flex-wrap items-center justify-center gap-4">
          <button
            onClick={openBook}
            className="group inline-flex items-center gap-3 text-black font-medium px-8 py-4 rounded-full hover:gap-4 transition-all duration-300"
            style={{ background: "var(--viimii-gold)" }}
          >
            Book Your Appointment
            <ArrowRight size={18} className="transition-transform group-hover:translate-x-1" />
          </button>
          <a
            href={BRAND.instagram}
            target="_blank"
            rel="noreferrer"
            className="inline-flex items-center gap-2 px-7 py-4 rounded-full border hairline text-cream/90 hover:text-gold hover:border-gold transition-colors"
          >
            <Instagram size={17} /> Follow {BRAND.instagramHandle}
          </a>
        </div>
      </div>

      {/* Reels showcase */}
      <div className="relative mt-14">
        <div className="flex items-center justify-center gap-2 mb-5 text-xs text-gold-soft section-line">
          <span className="w-2 h-2 rounded-full animate-pulse" style={{ background: "var(--viimii-rose)" }} />
          Featured Reels
        </div>
        <ReelsRow />
      </div>

      {/* stats */}
      <div className="relative max-w-3xl mx-auto px-5 mt-14 grid grid-cols-2 sm:grid-cols-4 gap-6 text-center">
        {STATS.map((s) => (
          <div key={s.label}>
            <div className="font-display text-3xl md:text-4xl gold-gradient-text">{s.value}</div>
            <div className="text-xs text-cream/55 mt-1 tracking-wide">{s.label}</div>
          </div>
        ))}
      </div>
    </section>
  );
}
